import React from 'react';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  footer: {
    backgroundColor: '#EEEEEE',
    padding: theme.spacing.unit * 6,
  },
  footerLink: {
    textDecoration: 'none',
    color: '#000000',
    fontSize: 14,
  },
  socialMediaList: {
    display: 'flex!important',
    listStyle: 'none!important',
    paddingLeft: '16px!important'
  },
  socialMediaItem: {
    marginRight: '16px!important',
  },
  socialIconLink: {
    textDecoration: 'none',
    color: '#000000',
  },
  socialIconButton: {
    textDecoration: 'none',
    color: 'transparent',
  }
})

const socialMedias = [
  {
    name: 'twitter',
    icon: 'M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M17.71,9.33C18.19,8.93 18.75,8.45 19,7.92C18.59,8.13 18.1,8.26 17.56,8.33C18.06,7.97 18.47,7.5 18.68,6.86C18.16,7.14 17.63,7.38 16.97,7.5C15.42,5.63 11.71,7.15 12.37,9.95C9.76,9.79 8.17,8.61 6.85,7.16C6.1,8.38 6.75,10.23 7.64,10.74C7.18,10.71 6.83,10.57 6.5,10.41C6.54,11.95 7.39,12.69 8.58,13.09C8.22,13.16 7.82,13.18 7.44,13.12C7.81,14.19 8.58,14.86 9.9,15C9,15.76 7.34,16.29 6,16.08C7.15,16.81 8.46,17.39 10.28,17.31C14.69,17.11 17.64,13.95 17.71,9.33Z',
    url: 'https://twitter.com/#!/CASTI_Inc'
  },
  {
    name: 'facebook',
    icon: 'M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z',
    url: 'http://www.facebook.com/CASTI.Inc'
  }
];

class Panel extends React.Component {

  render() {
    const { classes, menus } = this.props;
    const footer_menus = menus.footer_menus;

    return (
      <footer className={classNames(classes.layout)}>
        <Grid container spacing={32} justify="space-evenly">
          {footer_menus.map(footer => (
            <Grid item xs key={footer.title}>
              <Typography variant="h6" color="textPrimary" gutterBottom>
                {footer.title}
              </Typography>
              {footer.description.map(item => (
                <Typography key={item.name} variant="subtitle1" color="textSecondary">
                  <a target="_blank" className={classes.footerLink} href={item.url}>{item.name}</a>
                </Typography>
              ))}
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={32}>
          <ul className={classes.socialMediaList}>
            {socialMedias.map(mediaItem => (
              <li className={classes.socialMediaItem} key={mediaItem.name}>
                <a target="_blank" className={classes.socialIconLink} href={mediaItem.url}>
                  <SvgIcon><path d={mediaItem.icon} /></SvgIcon>
                </a>
              </li>
            ))}
          </ul>
        </Grid>
      </footer>
    );
  }
}

const Footer = withStyles(styles)((props) => <Panel {...props}/>);
export default Footer;
